document.addEventListener("DOMContentLoaded", initScripts);

function initScripts() {
  initScentSwitcher();

  initMoreScents();

  initPaymentPlans();
}

function initScentSwitcher() {
  const scents = document.querySelectorAll(".js-product-scent");

  scents.forEach((scent) => {
    scent.addEventListener("click", (event) => {
      event.preventDefault();
      const activeScent = document.querySelector(".js-product-scent.active");

      if (event.target !== activeScent) {
        switchScents(event.target);
      }
    });
  });
}

function switchScents(selectedScent) {
  const url = selectedScent.getAttribute("data-href");
  const sectionId = selectedScent.getAttribute("data-section-id");

  selectedScent.classList.add("loader");
  selectedScent.removeAttribute("data-hidden");

  const newColor = selectedScent.getAttribute("data-color");

  fetch(url)
    .then((res) => res.text())
    .then((data) => {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        // Replace Main Section
        const newMainSection = doc.querySelector(`#${sectionId}`);
        const currentMainSection = document.querySelector(`#${sectionId}`);
        if (newMainSection && currentMainSection) {
          currentMainSection
            .querySelector(".product-information")
            ?.style.setProperty("--pdp-theme-color", newColor);

          [
            ".product-information__media",
            '[data-type="header"]',
            ".js-payment-plans-block",
            ".buy-buttons-block",
            ".shipping",
            ".js-product-routine-wrapper",
          ].forEach((selector) =>
            swapElement(currentMainSection, newMainSection, selector),
          );
        }

        // Replace Multicolumn Section
        const newMulticolumnSection = doc.querySelector(
          `[data-section='product-multicolumn']`,
        )?.parentElement;
        const currentMulticolumnSection = document.querySelector(
          `[data-section='product-multicolumn']`,
        )?.parentElement;
        if (newMulticolumnSection && currentMulticolumnSection) {
          currentMulticolumnSection.replaceWith(newMulticolumnSection);
        }
        // Replace Scent Section
        const newScentSection = doc.querySelector(
          `[data-section='product-scent']`,
        )?.parentElement;
        const currentScentSection = document.querySelector(
          `[data-section='product-scent']`,
        )?.parentElement;
        // Read before swapping: replaceWith moves the node out of `doc`
        const isScentHidden = Boolean(
          doc
            .querySelector(`[data-section='product-scent']`)
            ?.hasAttribute("hidden"),
        );
        if (newScentSection && currentScentSection) {
          currentScentSection.replaceWith(newScentSection);
        }
        // Show or hide the scent section (hidden for Unscented)
        document
          .querySelector(`[data-section='product-scent']`)
          ?.toggleAttribute("hidden", isScentHidden);
        // Replace How To Section
        const newHowToSection =
          doc.querySelector(`[data-section='faq']`)?.parentElement;
        const currentHowToSection =
          document.querySelector(`[data-section='faq']`)?.parentElement;
        if (newHowToSection && currentHowToSection) {
          currentHowToSection.replaceWith(newHowToSection);
        }
        // Replace How To Section
        const newRecommendationsToSection = doc.querySelector(
          `[data-section='product-recommendations']`,
        )?.parentElement;
        const currentRecommendationsSection = document.querySelector(
          `[data-section='product-recommendations']`,
        )?.parentElement;
        if (newRecommendationsToSection && currentRecommendationsSection) {
          currentRecommendationsSection.replaceWith(
            newRecommendationsToSection,
          );
        }

        // Update URL without reload
        window.history.replaceState({}, "", url);

        selectedScent.classList.remove("loader");

        document.querySelectorAll(".js-product-scent")?.forEach((scent) => {
          if (
            scent.getAttribute("href") === selectedScent.getAttribute("href")
          ) {
            scent.classList.add("active");
            scent.removeAttribute("data-hidden");
          } else {
            scent.classList.remove("active");
          }
        });

        initPaymentPlans();
      } catch (err) {
        console.error("Processing error:", err);
        window.location.href = url;
      }
    })
    .catch((err) => {
      console.error("Fetch failed:", err);
      window.location.href = url;
    });
}

// Swap an element for its copy from the fetched page. If the new product
// doesn't render it, leave an empty hidden placeholder so a later switch
// can bring it back (replaceWith(null) would insert the text "null").
function swapElement(currentRoot, newRoot, selector) {
  const currentElement = currentRoot.querySelector(selector);
  if (!currentElement) return;

  const newElement = newRoot.querySelector(selector);
  if (newElement) {
    currentElement.replaceWith(newElement);
  } else {
    const placeholder = currentElement.cloneNode(false);
    placeholder.hidden = true;
    currentElement.replaceWith(placeholder);
  }
}

function initPaymentPlans() {
  const section = document.querySelector(
    '[data-section="product-information"]',
  );
  if (!section) return;

  const paymentPlans = section.querySelectorAll(".js-payment-plan");
  const paymentPlansFrequency = section.querySelector(
    ".js-payment-plans-frequency",
  );
  const subsaveOption = section.querySelector(".js-payment-plan-subsave");
  const sellingPlanInput = section.querySelector('input[name="selling_plan"]');
  const sellingPlans = section.querySelector(".js-selling-plans");
  const productPriceField = section.querySelector(".js-product-price");

  // Handle dropdown change
  if (sellingPlans) {
    sellingPlans.addEventListener("change", () => {
      if (sellingPlanInput && subsaveOption?.classList.contains("active")) {
        sellingPlanInput.value = sellingPlans.value;
      }
    });
  }

  // Handle plan selection
  paymentPlans.forEach((paymentPlan) => {
    paymentPlan.addEventListener("click", (e) => {
      if (e.target.closest(".js-selling-plans")) return;

      // reset all
      paymentPlans.forEach((plan) => {
        plan.classList.remove("active");

        const planInput = plan.querySelector(".js-payment-plan-input");
        if (planInput) {
          planInput.checked = false;
          planInput.removeAttribute("checked");
        }
      });

      // activate clicked
      paymentPlan.classList.add("active");

      const isSub = paymentPlan.classList.contains("js-payment-plan-subsave");
      const isOneTime = paymentPlan.classList.contains(
        "js-payment-plan-onetime",
      );

      if (paymentPlansFrequency) {
        paymentPlansFrequency.classList.toggle("active", isSub);
      }

      if (productPriceField && !productPriceField.closest('.button').classList.contains('cowlendar-btn')) {
        const oneTimePrice = section.querySelector(
          ".js-payment-plan-price-onetime",
        ).textContent;
        const subPrice = section.querySelector(
          ".js-payment-plan-price-subsave",
        ).textContent;

        productPriceField.textContent = ` - ${isSub ? subPrice : oneTimePrice}`;
      }

      const planInput = paymentPlan.querySelector(".js-payment-plan-input");
      if (planInput) {
        planInput.checked = true;
        planInput.setAttribute("checked", "checked");
      }

      // update selling plan
      if (sellingPlanInput) {
        sellingPlanInput.value = isOneTime ? "" : (sellingPlans?.value ?? "");
      }
    });
  });
}

function initMoreScents() {
  const productScents = document.querySelectorAll(".js-product-scent");
  const showMoreBtn = document.querySelector(".js-product-scents-btn");
  let visibleActiveScent = false;

  productScents?.forEach((scent, index) => {
    if (
      scent.classList.contains("active") &&
      scent.classList.contains("first")
    ) {
      visibleActiveScent = true;
    }
  });

  if (!visibleActiveScent) {
    toggleScents(productScents, showMoreBtn, "open");
  }

  showMoreBtn?.addEventListener("click", () => {
    if (showMoreBtn.dataset.close === "false") {
      toggleScents(productScents, showMoreBtn, "open");
    } else {
      toggleScents(productScents, showMoreBtn, "close");
    }
  });

  // Stop unnecessary navigation
  productScents?.forEach((scentPill) => {
    scentPill.addEventListener("click", (e) => {
      if (scentPill.classList.contains("active")) {
        e.preventDefault();
        return false;
      }
    });
  });
}

function toggleScents(scents, toggleButton, operation) {
  if (operation === "open") {
    scents.forEach((scent) => {
      scent.classList.remove("hidden");
      toggleButton.textContent = "Close";
      toggleButton.dataset.close = "true";
    });
  } else {
    scents.forEach((scent, index) => {
      if (scent.dataset.hidden === "true") {
        scent.classList.add("hidden");
        toggleButton.textContent = toggleButton.dataset.text;
        toggleButton.dataset.close = "false";
      }

      if (scent.classList.contains("active")) {
        scent.classList.add("first");
      } else {
        scent.classList.remove("first");
      }

      updateScentsVisibility();
    });
  }
}

// function updateScentsVisibility() {
//     const productScents = document.querySelectorAll('.js-product-scent');
//     const visiblePills = +document.querySelector('.js-pills').getAttribute('data-visible-pills');

//     productScents.forEach((scent, index) => {
//         if(index >= visiblePills) {
//             if(!scent.classList.contains('active')) {
//                 scent.setAttribute('data-hidden', 'true');
//                 scent.classList.add('hidden');
//             }
//         } else {
//             scent.removeAttribute('data-hidden');
//             scent.classList.remove('hidden');
//         }
//     })
// }
function updateScentsVisibility() {
  const container = document.querySelector(".js-pills");
  if(!container) return;

  const productScents = Array.from(
    container.querySelectorAll(".js-product-scent"),
  );
  const visiblePills = +container.getAttribute("data-visible-pills");
  const showMoreBtn = container.querySelector(".js-product-scents-btn");

  let visibleCount = 0;

  productScents.forEach((scent) => {
    const isActive = scent.classList.contains("active");

    if (visibleCount < visiblePills || isActive) {
      scent.classList.remove("hidden");
      scent.removeAttribute("data-hidden");
      visibleCount++;
    } else {
      scent.classList.add("hidden");
      scent.setAttribute("data-hidden", "true");
    }
  });

  // Update "+ More" button
  const hiddenCount = productScents.filter((s) =>
    s.classList.contains("hidden"),
  ).length;

  if (showMoreBtn) {
    if (hiddenCount > 0) {
      showMoreBtn.textContent = `+ ${hiddenCount} More`;
      showMoreBtn.style.display = "flex";
    } else {
      showMoreBtn.style.display = "none";
    }
  }
}
document.addEventListener("DOMContentLoaded", updateScentsVisibility);
